import { callApi } from "@/api/callApi";
import { API_ENDPOINT } from "../../api/constant";
import type {
  // IClientDetailsResponse,
  ILoginData,
  ILoginResponse,
} from "../../interface/auth.model";

export const AuthService = {
  login: async (payload: ILoginData): Promise<ILoginResponse> => {
    const API = `${API_ENDPOINT.auth}/login`;
    return callApi<ILoginResponse>(API, { method: "POST", data: payload });
  },

  logout: async (deviceId: string): Promise<ILoginResponse> => {
    const API = `${API_ENDPOINT.auth}/logout?deviceId=${deviceId}`;
    return callApi<ILoginResponse>(API, { method: "GET" });
  },

  // getClientDetails: async (params?: any): Promise<IClientDetailsResponse> => {
  //   // console.log("params", params);
  //   let API = `${API_ENDPOINT.oauth}/authorize`;
  //   if (params && Object.keys(params).length > 0) {
  //     const queryString = new URLSearchParams(params).toString();
  //     //   console.log("queryString", queryString);
  //     API += `?${queryString}`;
  //   }
  //   return callApi<IClientDetailsResponse>(API, { method: "GET" });
  // },
};
